import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { OverrideReportingRouter } from "./override-reporting.router";
import { reducers } from "./state/override-reporting.selectors";


@NgModule({
  imports: [
    OverrideReportingRouter,
    StoreModule.forFeature('overrideReporting', reducers),
  ],
  declarations: []
})
export class OverrideReportingScreenModule { }